import { render, staticRenderFns } from "./SearchDialog.vue?vue&type=template&id=0c044a2a&scoped=true&"
import script from "./SearchDialog.vue?vue&type=script&lang=js&"
export * from "./SearchDialog.vue?vue&type=script&lang=js&"
import style0 from "./SearchDialog.vue?vue&type=style&index=0&id=0c044a2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c044a2a",
  null
  
)

export default component.exports